import axios from 'axios';
import { isTokenExpired } from '../utils/tokenUtils';

const API_URL = process.env.REACT_APP_BASE_API_URL;

// ===============================================
// AXIOS PARA LOS ENDPOINTS
// ===============================================

const myApi = axios.create({

    baseURL: API_URL

});

// const { logOut } = useAuth();

// ===============================================
// AXIOS PARA LOS ENDPOINTS
// ===============================================

myApi.interceptors.request.use((config) => {

    const token = sessionStorage.getItem('ebt_token_fmcsa');

    if (token) {
        if (isTokenExpired(token)) {
            console.log("Token expirado");
            sessionStorage.removeItem('ebt_token_fmcsa');
            window.location.href = process.env.REACT_APP_URL_LOGIN;
            return Promise.reject("Token expirado");
        }

        config.headers['access-token'] = token;
    }

    return config;

}, (error) => {

    return Promise.reject(error);

});

myApi.interceptors.response.use((response) => {

    return response;

}, (error) => {

    if (error.response.status === 500) {

        //logOut();
        console.log(error)

    }

    if (error.response.status === 401) {

        sessionStorage.removeItem('ebt_token_fmcsa');
        window.location.href = process.env.REACT_APP_URL_LOGIN;

    }

    return Promise.reject(error);

});

export { myApi };